(function () {
  'use strict';

  var ROUTES = {
    'SH-P01-RES': ['01','02','03','05','04','08','07','10','11','15','16','18','19','21'],
    'SH-P02-RES': ['01','03','04','05','07','08','10','11','15','16','18','19','21'],
    'SH-P03-RES': ['01','02','14','03','05','09','04','08','10','11','15','16','18','19','21'],
    'SH-P04-RES': ['01','08','09','05','07','10','11','16','18','19','21'],
    'SH-P05-RES': ['01','07','04','05','08','10','11','15','16','18','19','21'],
    'SH-P06-RES': ['01','03','11','13','05','04','08','10','15','16','18','19','21'],
    'SH-B01-RES': ['01','16','17','18','08','10','19','21'],

    'SH-P01-CAP': ['01','02','03','05','04','08','07','10','11','15','16','18','19','21'],
    'SH-P02-CAP': ['01','03','04','05','07','08','10','11','15','16','18','19','21'],
    'SH-P03-CAP': ['01','02','14','03','05','09','04','08','10','11','15','16','18','19','21'],
    'SH-P04-CAP': ['01','08','09','05','07','10','11','16','18','19','21'],
    'SH-P05-CAP': ['01','07','04','05','08','10','11','15','16','18','19','21'],
    'SH-P07-CAP': ['01','03','11','05','04','08','10','15','16','18','19','21'],
    'SH-B01-CAP': ['01','16','17','18','08','10','19','21'],

    'AX-P01': ['01','02','14','03','04','05','06','08','07','10','11','15','16','18','19','21'],
    'AX-P02': ['01','03','04','05','06','07','08','10','11','15','16','18','19','21'],
    'AX-P03': ['01','02','03','04','05','06','07','08','10','11','15','16','18','19','21'],
    'AX-P04': ['01','02','03','04','05','06','07','08','10','11','15','16','18','19','21'],
    'AX-P05': ['01','02','03','04','05','06','07','08','10','11','15','16','18','19','21'],
    'AX-P06': ['01','05','06','08','07','09','04','10','11','15','16','18','19','21'],
    'AX-B01': ['01','16','17','18','08','10','19','21']
  };

  var PRODUCTS = {
    'shilajit-pure-organic-himalayan': { family: 'RES', hero: '__ec_resin_v3_commerce' },
    'shilajit-extract': { family: 'CAP', hero: '__ec_capsules_v7_hero' },
    'atlas-x-10-in-1-masculinity-maximiser': { family: 'AX', hero: '__ec_atlas_v7_hero' }
  };

  function analyticsAllowed() {
    try {
      return Boolean(window.Shopify && Shopify.customerPrivacy && typeof Shopify.customerPrivacy.analyticsProcessingAllowed === 'function' && Shopify.customerPrivacy.analyticsProcessingAllowed());
    } catch (error) { return false; }
  }

  function track(name, properties) {
    if (!analyticsAllowed()) return;
    try {
      if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture(name, properties);
    } catch (error) { /* analytics must never block routing */ }
  }

  function productHandle() {
    var match = window.location.pathname.match(/^\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function sectionWrapper(number, product) {
    if (number === '01') return document.querySelector('[id*="' + product.hero + '"]');
    var marker = document.querySelector('[data-ec-section-id="EC-SEC-' + number + '"], [data-ec-section="EC-SEC-' + number + '"]');
    if (!marker) marker = document.getElementById('ec-sec-' + number);
    return marker ? marker.closest('.shopify-section') : null;
  }

  function ensureResinSection13(product) {
    if (product.family !== 'RES' || sectionWrapper('13', product)) return;
    var anchor = sectionWrapper('14', product) || sectionWrapper('15', product);
    if (!anchor || !anchor.parentElement) return;

    var wrapper = document.createElement('section');
    wrapper.className = 'shopify-section ec-sot-v3-shopify-section ec-resin-pdp-v3-shopify-section';
    wrapper.id = 'shopify-section-ec-route-resin-sec-13';
    wrapper.innerHTML = '<section class="ec-sot-v3-section ec-section ec-sec-13" data-ec-section="EC-SEC-13" aria-labelledby="ec-route-sec-13-title">' +
      '<div class="ec-sensory" data-reveal>' +
        '<header class="ec-sensory__header"><div><p class="ec-eyebrow">The Resin experience</p><h2 id="ec-route-sec-13-title">Real Resin has character.</h2></div><p>Earthy in taste and smell. Naturally variable in texture. Simple to prepare.</p></header>' +
        '<div class="ec-sensory__band" role="tablist" aria-label="Explore Resin taste, smell and texture" style="--ec-sensory-image:url(\'/cdn/shop/t/31/assets/ec-resin-character-v2.jpg\')">' +
          '<button class="ec-sensory__choice is-active" type="button" role="tab" aria-selected="true" data-sensory-choice data-sensory-label="Taste" data-sensory-tip="The taste is deliberately potent and earthy. A sweet or mild taste is not the traditional Resin experience."><small>01</small><strong>Taste</strong><span>Potent and earthy</span></button>' +
          '<button class="ec-sensory__choice" type="button" role="tab" aria-selected="false" data-sensory-choice data-sensory-label="Smell" data-sensory-tip="The smell is naturally intense and resinous. If Resin smells perfumed or unusually pleasant, question what has been added or altered."><small>02</small><strong>Smell</strong><span>Intense and resinous</span></button>' +
          '<button class="ec-sensory__choice" type="button" role="tab" aria-selected="false" data-sensory-choice data-sensory-label="Texture" data-sensory-tip="Texture varies significantly between batches because of seasonality, rock-harvest location and temperature. Firm when cool; softer when warm."><small>03</small><strong>Texture</strong><span>Naturally variable</span></button>' +
        '</div>' +
        '<div class="ec-sensory__tip" role="tabpanel" aria-live="polite"><span data-sensory-current-label>Taste</span><p data-sensory-current>The taste is deliberately potent and earthy. A sweet or mild taste is not the traditional Resin experience.</p></div>' +
      '</div>' +
    '</section>';
    anchor.parentElement.insertBefore(wrapper, anchor);

    var choices = Array.prototype.slice.call(wrapper.querySelectorAll('[data-sensory-choice]'));
    choices.forEach(function (choice) {
      choice.addEventListener('click', function () {
        choices.forEach(function (item) {
          var active = item === choice;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        wrapper.querySelector('[data-sensory-current-label]').textContent = choice.getAttribute('data-sensory-label');
        wrapper.querySelector('[data-sensory-current]').textContent = choice.getAttribute('data-sensory-tip');
      });
    });
  }

  function ensureAtlasSection09(product) {
    if (product.family !== 'AX' || sectionWrapper('09', product)) return;
    var anchor = sectionWrapper('10', product) || sectionWrapper('11', product);
    if (!anchor || !anchor.parentElement) return;

    var wrapper = document.createElement('section');
    wrapper.className = 'shopify-section';
    wrapper.id = 'shopify-section-ec-route-atlas-sec-09';
    wrapper.innerHTML = '<section class="ec-atlas-trust" id="ec-sec-09" data-ec-section="EC-SEC-09" aria-labelledby="ec-atlas-trust-title">' +
      '<div class="ec-atlas-trust__inner">' +
        '<p class="ec-atlas-trust__eyebrow">BUILT TO BE INSPECTED</p>' +
        '<h2 id="ec-atlas-trust-title">Why Essencraft? Because trust should be visible.</h2>' +
        '<div class="ec-atlas-trust__spine" aria-label="Five reasons to trust Essencraft">' +
          '<button type="button" data-open-trust-detail data-trust-title="Carefully sourced products" data-trust-body="Atlas X is built as one purpose-led formula. Every listed active ingredient and amount is disclosed, so you can inspect what you are choosing before you buy." data-trust-target="#ec-sec-06" data-trust-cta="Inspect the formula"><b>01</b><span>Carefully sourced products</span><i aria-hidden="true">→</i></button>' +
          '<button type="button" data-open-trust-detail data-trust-title="Finished-product testing" data-trust-body="The named Atlas X finished-product sample was analysed by Eurofins. Its report identity and measured results are available directly on this page." data-trust-target="#ec-sec-08" data-trust-cta="See the Atlas X report"><b>02</b><span>Finished-product testing</span><i aria-hidden="true">→</i></button>' +
          '<button type="button" data-open-trust-detail data-trust-title="Clear composition" data-trust-body="Ten listed active ingredients. Every amount declared per two-capsule daily serving. No proprietary blend hiding the individual quantities." data-trust-target="#ec-sec-05" data-trust-cta="Explore the composition"><b>03</b><span>Clear composition</span><i aria-hidden="true">→</i></button>' +
          '<button type="button" data-open-trust-detail data-trust-title="Useful research education" data-trust-body="We turn relevant ingredient research into concise, plain-English summaries, while keeping the original study available for anyone who wants to inspect it." data-trust-target="#ec-sec-07" data-trust-cta="Explore the research"><b>04</b><span>Useful research education</span><i aria-hidden="true">→</i></button>' +
          '<button type="button" data-open-trust-detail data-trust-title="Transparent pricing and subscription control" data-trust-body="The first charge, future charge, delivery cadence and one-time price stay visible before you commit. Subscription controls remain clearly accessible." data-trust-target="#ec-sec-16" data-trust-cta="Return to the offer"><b>05</b><span>Transparent pricing and subscription control</span><i aria-hidden="true">→</i></button>' +
        '</div>' +
      '</div>' +
      '<dialog class="ec-atlas-trust-dialog" data-atlas-trust-dialog aria-labelledby="ec-atlas-trust-dialog-title">' +
        '<div class="ec-atlas-trust-dialog__panel">' +
          '<button class="ec-atlas-trust-dialog__close" type="button" data-close-trust-detail aria-label="Close trust detail">×</button>' +
          '<p class="ec-atlas-trust__eyebrow">WHY ESSENCRAFT</p>' +
          '<h2 id="ec-atlas-trust-dialog-title" data-trust-dialog-title></h2>' +
          '<p data-trust-dialog-body></p>' +
          '<a href="#ec-sec-06" data-trust-dialog-link><span data-trust-dialog-cta>Inspect the evidence</span><b aria-hidden="true">→</b></a>' +
        '</div>' +
      '</dialog>' +
    '</section>';
    anchor.parentElement.insertBefore(wrapper, anchor);

    var dialog = wrapper.querySelector('[data-atlas-trust-dialog]');
    var dialogTitle = wrapper.querySelector('[data-trust-dialog-title]');
    var dialogBody = wrapper.querySelector('[data-trust-dialog-body]');
    var dialogLink = wrapper.querySelector('[data-trust-dialog-link]');
    var dialogCta = wrapper.querySelector('[data-trust-dialog-cta]');
    function closeDialog() { if (dialog && dialog.open) dialog.close(); }
    Array.prototype.forEach.call(wrapper.querySelectorAll('[data-open-trust-detail]'), function (button) {
      button.addEventListener('click', function () {
        dialogTitle.textContent = button.getAttribute('data-trust-title') || '';
        dialogBody.textContent = button.getAttribute('data-trust-body') || '';
        dialogLink.href = button.getAttribute('data-trust-target') || '#ec-sec-16';
        dialogCta.textContent = button.getAttribute('data-trust-cta') || 'Inspect the evidence';
        if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      });
    });
    wrapper.querySelector('[data-close-trust-detail]').addEventListener('click', closeDialog);
    dialog.addEventListener('click', function (event) { if (event.target === dialog) closeDialog(); });
    dialogLink.addEventListener('click', closeDialog);
  }

  function ensureAtlasSection17(product) {
    if (product.family !== 'AX' || sectionWrapper('17', product)) return;
    var anchor = sectionWrapper('18', product) || sectionWrapper('19', product);
    if (!anchor || !anchor.parentElement) return;

    var wrapper = document.createElement('section');
    wrapper.className = 'shopify-section';
    wrapper.id = 'shopify-section-ec-route-atlas-sec-17';
    wrapper.innerHTML = '<section class="ec-atlas-control" id="ec-sec-17" data-ec-section="EC-SEC-17" aria-labelledby="ec-atlas-control-title">' +
      '<div class="ec-atlas-control__inner"><div class="ec-atlas-control__panel">' +
        '<header class="ec-atlas-control__header"><div><p class="ec-atlas-control__eyebrow">SUBSCRIPTION CONTROL</p><h2 id="ec-atlas-control-title">Your delivery stays under your control.</h2></div><p>Change the date, skip a delivery, switch frequency, pause or cancel securely through Recharge.</p></header>' +
        '<nav class="ec-atlas-control__actions" aria-label="Atlas X subscription controls">' +
          '<a href="/account/login" aria-label="Sign in securely to change your next delivery date"><span>01</span><strong>Change next date</strong><b aria-hidden="true">→</b></a>' +
          '<a href="/account/login" aria-label="Sign in securely to skip your next delivery"><span>02</span><strong>Skip next delivery</strong><b aria-hidden="true">→</b></a>' +
          '<a href="/account/login" aria-label="Sign in securely to change your delivery frequency"><span>03</span><strong>Change frequency</strong><b aria-hidden="true">→</b></a>' +
          '<a href="/account/login" aria-label="Sign in securely to swap your subscription product where available"><span>04</span><div><strong>Swap product</strong><small>where available</small></div><b aria-hidden="true">→</b></a>' +
          '<a href="/account/login" aria-label="Sign in securely to pause your subscription"><span>05</span><strong>Pause subscription</strong><b aria-hidden="true">→</b></a>' +
          '<a href="/account/login" aria-label="Sign in securely to cancel your subscription"><span>06</span><strong>Cancel subscription</strong><b aria-hidden="true">→</b></a>' +
        '</nav>' +
        '<footer class="ec-atlas-control__footer"><span>SECURE RECHARGE ACCOUNT</span><p>No calls. No hidden process. You choose what happens next.</p><a href="/account/login">Open my controls <b aria-hidden="true">→</b></a></footer>' +
      '</div></div>' +
    '</section>';
    anchor.parentElement.insertBefore(wrapper, anchor);
  }

  function validForProduct(route, family) {
    if (family === 'AX') return route.indexOf('AX-') === 0;
    return route.slice(-4) === '-' + family;
  }

  function applyPdpSectionFlow() {
    if (document.documentElement.getAttribute('data-ec-pdp-flow-enabled') !== 'true') return;

    var wrappers = Array.prototype.slice.call(document.querySelectorAll('[data-ec-section-id^="EC-SEC-"], [data-ec-section^="EC-SEC-"], [id^="ec-sec-"]'))
      .map(function (marker) { return marker.closest('.shopify-section'); })
      .filter(function (wrapper, index, list) { return wrapper && list.indexOf(wrapper) === index; });

    wrappers.forEach(function (wrapper) {
      var marker = wrapper.querySelector('[data-ec-section-id^="EC-SEC-"], [data-ec-section^="EC-SEC-"], [id^="ec-sec-"]');
      var value = marker ? (marker.getAttribute('data-ec-section-id') || marker.getAttribute('data-ec-section') || marker.id) : '';
      var match = value.match(/(?:EC-SEC-|ec-sec-)(\d+)/i);
      if (match && match[1].padStart(2, '0') !== '01') wrapper.setAttribute('data-ec-pdp-flow-section', 'true');
      else wrapper.removeAttribute('data-ec-pdp-flow-section');
    });
  }

  function applyRoute() {
    var params = new URLSearchParams(window.location.search);
    var route = params.get('ec_build_route') || '';
    var assignmentId = params.get('ec_assignment_id') || '';
    var handle = productHandle();
    var product = PRODUCTS[handle];

    if (!product) return;
    applyPdpSectionFlow();
    if (!route || !assignmentId || !ROUTES[route] || !validForProduct(route, product.family)) return;

    var nativeTemplateSuffix = document.documentElement.getAttribute('data-ec-template-suffix') || '';
    if (nativeTemplateSuffix === route.toLowerCase()) {
      var nativeWrappers = Array.prototype.slice.call(document.querySelectorAll('[data-ec-section-id^="EC-SEC-"], [data-ec-section^="EC-SEC-"], [id^="ec-sec-"]'))
        .map(function (marker) { return marker.closest('.shopify-section'); })
        .filter(function (wrapper, index, list) { return wrapper && list.indexOf(wrapper) === index; });
      var nativeOrder = nativeWrappers.map(function (wrapper, index) {
        wrapper.setAttribute('data-ec-route-visible', 'true');
        wrapper.setAttribute('data-ec-route-position', String(index + 1));
        var marker = wrapper.querySelector('[data-ec-section-id^="EC-SEC-"], [data-ec-section^="EC-SEC-"], [id^="ec-sec-"]');
        var value = marker ? (marker.getAttribute('data-ec-section-id') || marker.getAttribute('data-ec-section') || marker.id) : '';
        var match = value.match(/(?:EC-SEC-|ec-sec-)(\d+)/i);
        return match ? 'EC-SEC-' + match[1].padStart(2, '0') : value;
      }).filter(Boolean);
      document.documentElement.setAttribute('data-ec-active-pdp-route', route);
      track('ec_pdp_route_applied', {
        route_id: route,
        assignment_id: assignmentId,
        experiment_version: params.get('ec_experiment_version') || '',
        product_handle: handle,
        section_order: nativeOrder,
        native_editable_template: true
      });
      applyPdpSectionFlow();
      return;
    }

    if (ROUTES[route].indexOf('13') !== -1) ensureResinSection13(product);
    if (ROUTES[route].indexOf('09') !== -1) ensureAtlasSection09(product);
    if (ROUTES[route].indexOf('17') !== -1) ensureAtlasSection17(product);

    var order = ROUTES[route];
    var wrappers = {};
    var missing = [];
    order.forEach(function (number) {
      wrappers[number] = sectionWrapper(number, product);
      if (!wrappers[number]) missing.push(number);
    });

    if (missing.length) {
      track('ec_pdp_route_sequence_failed', {
        route_id: route,
        assignment_id: assignmentId,
        product_handle: handle,
        missing_section_ids: missing.map(function (number) { return 'EC-SEC-' + number; })
      });
      return;
    }

    var parent = wrappers[order[0]].parentElement;
    if (!parent || order.some(function (number) { return wrappers[number].parentElement !== parent; })) return;

    var allGoverned = Array.prototype.slice.call(parent.querySelectorAll('[data-ec-section-id^="EC-SEC-"], [data-ec-section^="EC-SEC-"], [id^="ec-sec-"]'))
      .map(function (marker) { return marker.closest('.shopify-section'); })
      .filter(function (wrapper, index, list) { return wrapper && list.indexOf(wrapper) === index; });

    allGoverned.forEach(function (wrapper) {
      wrapper.hidden = true;
      wrapper.setAttribute('aria-hidden', 'true');
      wrapper.setAttribute('data-ec-route-visible', 'false');
    });

    order.forEach(function (number, index) {
      var wrapper = wrappers[number];
      wrapper.hidden = false;
      wrapper.removeAttribute('aria-hidden');
      wrapper.setAttribute('data-ec-route-visible', 'true');
      wrapper.setAttribute('data-ec-route-position', String(index + 1));
      parent.appendChild(wrapper);
    });

    document.documentElement.setAttribute('data-ec-active-pdp-route', route);
    var robots = document.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement('meta');
      robots.name = 'robots';
      document.head.appendChild(robots);
    }
    robots.content = 'noindex,follow';

    track('ec_pdp_route_applied', {
      route_id: route,
      assignment_id: assignmentId,
      experiment_version: params.get('ec_experiment_version') || '',
      product_handle: handle,
      section_order: order.map(function (number) { return 'EC-SEC-' + number; })
    });
    applyPdpSectionFlow();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyRoute, { once: true });
  else applyRoute();
}());
